// extracted by mini-css-extract-plugin
module.exports = {"title":"richTextComponent_title__p1TXt","rte":"richTextComponent_rte__FjXZ8"};